getEffects